export default function reverseTranslateCreator(translations) {
  const keyMap = Object.keys(translations).reduce(
    (acc, key) =>
      Object.assign(acc, {
        [translations[key]]: key,
      }),
    {},
  )

  return translation => keyMap[translation] || translation
}
